import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  name: 'María L.',
  text: 'Buscaba una forma de generar un ingreso extra desde casa y este kit me ayudó a animarme. Hoy no solo aprendí algo hermoso, también hago la decoración para los cumpleaños y eventos de mis hijos.'
}, {
  name: 'Sofía G.',
  text: 'Nunca había hecho tricotín y me sorprendió lo fácil que fue entender el proceso. Ya hice mis primeras creaciones y quedaron hermosas.'
}, {
  name: 'Luciana R.',
  text: 'Lo compré como hobby y terminé viendo que realmente tenía potencial para vender. Me motivó muchísimo.'
}, {
  name: 'Camila V.',
  text: 'Es súper lindo, visual y completo. Se nota que está hecho con amor y pensado para acompañarte de verdad.'
}];
// Extracted card content to avoid duplication
function TestimonialContent({
  testimonial,
  visible = true
}: {
  testimonial: (typeof testimonials)[number];
  visible?: boolean;
}) {
  return <div className={`bg-brand-card p-6 sm:p-8 md:p-12 rounded-2xl sm:rounded-[2rem] shadow-sm border border-brand-accent/10 flex flex-col justify-center items-center text-center ${!visible ? 'invisible' : ''}`} data-id="element-185">
      <div className="flex gap-1 mb-4 sm:mb-6" data-id="element-186">
        {[...Array(5)].map((_, j) => <Star key={j} className="text-brand-cta fill-brand-cta w-5 h-5 sm:w-6 sm:h-6" data-id="element-187" />)}
      </div>
      <p className="text-base sm:text-xl md:text-2xl text-brand-text/90 leading-relaxed mb-6 sm:mb-8 font-sans italic" data-id="element-188">
        "{testimonial.text}"
      </p>
      <p className="font-serif font-bold text-brand-deep-green text-xl sm:text-2xl" data-id="element-189">
        {testimonial.name}
      </p>
    </div>;
}
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextTestimonial = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % testimonials.length);
  };
  const prevTestimonial = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };
  useEffect(() => {
    const timer = setInterval(nextTestimonial, 5000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto bg-brand-alt-bg/20" data-id="element-190">
      <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-191">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl text-brand-text mb-4" data-id="element-192">
          Lo que dicen nuestras clientas
        </h2>
        <p className="text-lg sm:text-xl text-brand-text/80 font-serif italic" data-id="element-193">
          Experiencias reales de mujeres que se animaron a empezar
        </p>
      </div>

      <div className="relative max-w-4xl mx-auto px-10 sm:px-14" data-id="element-194">
        <div className="relative" data-id="element-195">
          {/* Invisible sizer: renders current testimonial to set natural height */}
          <div aria-hidden="true" className="invisible" data-id="element-196">
            <TestimonialContent testimonial={testimonials[currentIndex]} visible={false} data-id="element-197" />
          </div>

          {/* Animated overlay */}
          <div className="absolute inset-0" data-id="element-198">
            <AnimatePresence mode="wait" data-id="element-199">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 50
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -50
            }} transition={{
              duration: 0.3
            }} className="h-full" data-id="element-200">
                <TestimonialContent testimonial={testimonials[currentIndex]} data-id="element-201" />
              </motion.div>
            </AnimatePresence>
          </div>
        </div>

        <button onClick={prevTestimonial} className="absolute left-0 top-1/2 -translate-y-1/2 bg-brand-card p-2 sm:p-3 rounded-full shadow-md border border-brand-accent/10 text-brand-text hover:text-brand-cta transition-colors z-10" aria-label="Previous testimonial" data-id="element-202">
          <ChevronLeft className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-203" />
        </button>
        <button onClick={nextTestimonial} className="absolute right-0 top-1/2 -translate-y-1/2 bg-brand-card p-2 sm:p-3 rounded-full shadow-md border border-brand-accent/10 text-brand-text hover:text-brand-cta transition-colors z-10" aria-label="Next testimonial" data-id="element-204">
          <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-205" />
        </button>

        <div className="flex justify-center gap-2 mt-6 sm:mt-8" data-id="element-206">
          {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-3 h-3 rounded-full transition-colors ${idx === currentIndex ? 'bg-brand-cta' : 'bg-brand-accent/30'}`} aria-label={`Go to testimonial ${idx + 1}`} data-id="element-207" />)}
        </div>
      </div>
    </section>;
}